function NoMatch() {
  return (
    <div className="container">
      <p>Nothing Found</p>
    </div>
  );
}

export default NoMatch;